// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InfoCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/InfoCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleOutlinedSvg
  }));
};

InfoCircleOutlined.displayName = 'InfoCircleOutlined';
export default React.forwardRef(InfoCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/InfoCircleOutlined.js
// module id = 1351
// module chunks = 0